const positionSlotAssignmentValidationSchema = {
  employeeAlias: { type: 'string', required: false },
  requiredReplacement: { type: 'boolean', required: false },
};

export const getPositionSlotAssignmentValidationSchema = () => Promise.resolve(positionSlotAssignmentValidationSchema);
